import PlanForm from '@/view/forms/plan-form'
import { List, PlusCircle } from 'lucide-react'
import { useState } from 'react'
import { Tabs, TabsList, TabsTrigger } from '../../components/ui/tabs'
import { DisplayPlans } from './panels/display-plans'

interface IPlansPage {}

export default function PlansPage(props: IPlansPage) {
  console.log(props)

  const [tab, setTab] = useState('plans')

  return (
    <div className="w-full">
      <main className="flex flex-col gap-6">
        <div className="w-full overflow-y-scrol flex justify-between">
          <Tabs defaultValue="plans" className="w-[320px]" onValueChange={setTab}>
            <TabsList>
              <TabsTrigger value="plans" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <List className="text-sm" />
                Lista de Planos
              </TabsTrigger>
              <TabsTrigger value="register-plan" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <PlusCircle className="text-sm" />
                Cadastrar Plano
              </TabsTrigger>
            </TabsList>
          </Tabs>

          {/* <div className="flex gap-2">
            <Button className="text-muted flex gap-2 text-sm" variant="outline">
              <ListFilter />
              Filtro
            </Button>
          </div> */}
        </div>
        <div className="flex flex-col gap-4 border-acelerafit-gray-white rounded-md border p-6">
          {tab == 'plans' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Planos</h3>
                <p className="text-sm text-acelerait-black">Gerencie e acompanhe o cadastro, status e informações dos Planos.</p>
              </header>
              <div className="h-container-members overflow-hidden">
                <DisplayPlans />
              </div>
            </>
          )}

          {tab == 'register-plan' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Adicionar Plano</h3>
                <p className="text-sm text-acelerafit-gray-dark">Preencha as informações abaixo para registrar um novo plano.</p>
              </header>
              <PlanForm />
            </>
          )}
        </div>
      </main>
    </div>
  )
}
